var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPinnedPostsEmptystate = function SvgPinnedPostsEmptystate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.273,
    y: 68.683,
    width: 47.191,
    height: 10.487,
    rx: 0.141,
    transform: "rotate(-135 85.273 68.683)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m65.456 90.978.049-.049c7.508-7.508 5.571-21.618-4.326-31.515-9.897-9.898-24.007-11.834-31.516-4.326L65.504 90.93l-.048.048Z",
    fill: "url(#pinned-posts-emptystate_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.105 72.494c-1.329-4.576-4.002-9.163-7.927-13.087-3.923-3.924-8.509-6.596-13.082-7.925l9.992-9.993 21.01 21.01-9.993 9.995Z",
    fill: "url(#pinned-posts-emptystate_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.895 88.458 9.887-17.303 7.415 7.415-17.303 9.888Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.929 71.928c-1.38-4.384-3.992-8.752-7.752-12.512C51.28 49.519 37.17 47.582 29.66 55.09l-.098.099.099-.098 23.755 23.755c2.146-2.084 4.472-4.03 6.458-5.023 3.038-1.52 6.565-1.907 9.054-1.895Z",
    fill: "url(#pinned-posts-emptystate_svg__c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinned-posts-emptystate_svg__a",
    x1: 65.103,
    y1: 75.59,
    x2: 60.741,
    y2: 89.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinned-posts-emptystate_svg__b",
    x1: 61.629,
    y1: 59.834,
    x2: 72.99,
    y2: 47.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinned-posts-emptystate_svg__c",
    x1: 65.113,
    y1: 72.947,
    x2: 41.471,
    y2: 65.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};

export default SvgPinnedPostsEmptystate;